module.exports = __webpack_public_path__ + "static/pauline-988fdfb3b761f328ffe1d6db1163168d.png";